import { useEffect } from "react";
import { RocketLaunch } from "@phosphor-icons/react";
import { useFetch } from "@/lib/useFetch";

export const PreviewBanner = () => {
  const { data, reload } = useFetch("/site");
  useEffect(() => {
    window.addEventListener("site-changed", reload);
    return () => window.removeEventListener("site-changed", reload);
  }, [reload]);
  if (!data?.preview_mode) return null;
  return (
    <div className="relative z-50 border-b-2 border-[#E0A21B] bg-[#E0A21B] px-4 py-2 text-center text-xs font-bold text-[#0B1B33] sm:text-sm" role="status" data-testid="preview-banner">
      <RocketLaunch weight="fill" className="mr-1.5 inline" />
      LAUNCHING SOON · Preview site. Bookings made now are test bookings only and will be cleared before launch.
    </div>
  );
};
